import { doc, setDoc } from 'firebase/firestore';
import { mapValues } from 'lodash';
import { useDocumentDataOnce } from 'react-firebase-hooks/firestore';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { Link, useParams } from 'react-router-dom';
import TheSpinner from '../components/global/TheSpinner';
import { myFirestore } from './config';
import RichTextInput from './fields/RichTextInput';
import TextInput from './fields/TextInput';

const EditForm = ({ id, data }) => {
    const {
        register,
        handleSubmit,
        setValue,
        formState: { errors },
    } = useForm({
        defaultValues: data,
    });

    const onSubmit = async data => {
        data = mapValues(data, row => row || '');
        const myCollection = doc(myFirestore, `phase/${id}`);
        await setDoc(myCollection, data);
        toast.success('Phase has been Saved');
    };

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <div className="flex flex-col gap-2">
                <TextInput
                    id="slug"
                    title="Unique Slug"
                    register={register('slug', {
                        required: 'Slug is required',
                    })}
                    errors={errors}
                />
                <TextInput
                    id="title"
                    title="Page Title"
                    register={register('title', {
                        required: 'Title is required',
                    })}
                    errors={errors}
                />
                <RichTextInput
                    id="synopsis"
                    title="Synopsis"
                    register={register('synopsis')}
                    setValue={setValue}
                    data={data}
                    errors={errors}
                />
                <RichTextInput
                    id="description"
                    title="Description"
                    register={register('description')}
                    setValue={setValue}
                    data={data}
                    errors={errors}
                />
                <RichTextInput
                    id="overview"
                    title="Stage Overview"
                    register={register('overview')}
                    setValue={setValue}
                    data={data}
                    errors={errors}
                />
                <RichTextInput
                    id="responsibilities"
                    title="Client Responsibilities"
                    register={register('responsibilities')}
                    setValue={setValue}
                    data={data}
                    errors={errors}
                />
                <RichTextInput
                    id="documents"
                    title="Related documents"
                    register={register('documents')}
                    setValue={setValue}
                    data={data}
                    errors={errors}
                />
                <TextInput
                    id="video"
                    title="Instructional Video URL"
                    register={register('video')}
                    errors={errors}
                />
                <div>
                    <button
                        type="submit"
                        className="border rounded bg-gray-50 hover:bg-gray-100 px-3 py-1"
                    >
                        Update phase
                    </button>
                </div>
            </div>
        </form>
    );
};

const AdminPhaseEdit = () => {
    const { id } = useParams();

    const [data, loading, error] = useDocumentDataOnce(
        doc(myFirestore, `phase/${id}`)
    );

    const renderBody = () => {
        if (loading) return <TheSpinner />;

        if (error) return <div>{error}</div>;

        return <EditForm id={id} data={data} />;
    };

    return (
        <>
            <h1 className="text-4xl">Edit Phase</h1>
            <div className="py-12 flex flex-col">
                <Link to="/admin/phase" className="mb-6">
                    Back to phase list
                </Link>

                {renderBody()}
            </div>
        </>
    );
};

export default AdminPhaseEdit;
